import * as React from "react";
const SvgSelectAll20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M14.159 6.393 7.552 13 3.9 9.348l1.393-1.393 2.259 2.259L12.766 5l1.393 1.393Z"
    }),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M17 2H1v14h16V2ZM3 14V4h12v10H3Z",
      clipRule: "evenodd"
    }),
    React.createElement("path", { fill: "current", d: "M18 7h2v12H6v-2h12V7Z" })
  );
export default SvgSelectAll20Px;
